import { render, staticRenderFns } from "./strategyTagRelation.vue?vue&type=template&id=70628468&scoped=true&"
import script from "./strategyTagRelation.vue?vue&type=script&lang=ts&"
export * from "./strategyTagRelation.vue?vue&type=script&lang=ts&"
import style0 from "./strategyTagRelation.vue?vue&type=style&index=0&id=70628468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70628468",
  null
  
)

export default component.exports